<template>
  <ak-card>
    <ak-card-body class="block">
      <div><h3 class="color-grey">Outbound</h3></div>

      <!-- no profiles on account -->
      <ak-empty-state
        v-if="!hasProfile"
        icon="document-text"
        icon-size="gigantic"
      >
        <h3 class="color-grey">There are no profiles</h3>
        <p>
          Create a connection profile to send {{ leadTerm }} data to an SFTP
          server through automation.
        </p>
        <ak-button @click="createProfile()">Add Profile</ak-button>
      </ak-empty-state>

      <!-- at least one profile on account -->
      <ak-integration-s-f-t-p-profiles
        v-else
        :service="service"
        :profile-service="profileService"
      />

      <!-- profile management drawer -->
      <ak-integration-s-f-t-p-profile :service="profileService" />
    </ak-card-body>
  </ak-card>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { entityBranding } from '@akerolabs/akero-vue/src/services/entityBranding.js'
import useSFTPProfile from './useSFTPProfile'

import EmptyState from '@akerolabs/akero-vue/src/components/emptyState/EmptyState.vue'
import IntegrationSFTPProfile from './IntegrationSFTPProfile.vue'
import IntegrationSFTPProfiles from './IntegrationSFTPProfiles.vue'

export default defineComponent({
  name: 'AkIntegrationSFTPOutbound',
  components: {
    [EmptyState.name]: EmptyState,
    [IntegrationSFTPProfile.name]: IntegrationSFTPProfile,
    [IntegrationSFTPProfiles.name]: IntegrationSFTPProfiles,
  },
  provide() {
    return {
      akCards: undefined, // stub unneeded dependency
    }
  },
  props: {
    service: {
      required: true,
      type: Object,
    },
  },
  setup(props) {
    const profileService = useSFTPProfile(props.service)

    /**
     * Initialise the profile service for new profile creation
     */
    const createProfile = () => profileService.initForNew()

    /**
     * Determine if the SFTP outbound integration has at least one profile
     * @type {ComputedRef<*>}
     */
    const hasProfile = computed(
      () => props.service.outboundProfiles.value.length,
    )

    const leadTerm = entityBranding('leads.singular', 'Lead')

    return {
      profileService,
      createProfile,
      hasProfile,
      leadTerm,
    }
  },
})
</script>
